import React from "react";
import styles from "./ProjectLibraryPage.module.css";
import OtherNAV from "../../jene/home/home-nav/ParentOtherNAV";
import Filter from "./ComponentsForProjectLibrary/Filter";
import HomeFOO from "../../jene/home/home-foo/HomeFOO";

export default function ProjectLibraryPage() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });  //it will scroll the window smoothly to the top of the page
  };

  return (
    <div className={styles.containerProjectLibraryPage}>
      <OtherNAV />
      <div className={styles.projectText}>
        <h1>PROJECTS</h1> <br />
        <p>Welcome to the project library. You can use the filters on the right to help you search for specific projects.</p>
      </div>
      <Filter />
      <div className={styles.bttButtonDiv}>
        <button className={styles.backToTopButton} onClick={scrollToTop}>
          BACK TO TOP
        </button>
      </div>
      <HomeFOO />
    </div>
  );
}
